import { useMemo } from 'react';

import type { ApiClient } from './client';
import { createApiClient } from './client';

import { useSession } from '@/auth';

/** An API client bound to the current session's access token. */
export const useApiClient = (): ApiClient => {
  const { getAccessToken, clearSession } = useSession();

  return useMemo(
    () => createApiClient(getAccessToken, { onUnauthorized: clearSession }),
    [getAccessToken, clearSession],
  );
};
